import styled from 'styled-components'
import { Toast as ToastBase } from '@chilecompra/react-kit/components'

export const SearchGridLayout = styled('div')`
  display: grid;
  gap: 16px;
  grid-template-areas:
    'error'
    'new-quote-box'
    'heading-filters'
    'notificationBottom'
    'resume'
    'filters'
    'results';
  grid-template-columns: 1fr;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    ${props => {
      if (props.isBuyer)
        return `
        grid-template-areas:
          'error error error'
          'heading-filters heading-filters new-quote-box'
          'notificationBottom notificationBottom notificationBottom'
          'resume resume resume'
          'filters filters filters'
          'results results results';
        grid-template-columns: 250px 1fr 239px;
      `
      if (props.isSeller)
        return `
        grid-template-areas:
          'error error'
          'heading-filters heading-filters'
          'notificationBottom notificationBottom'
          'resume resume'
          'filters filters'
          'results results';
        grid-template-columns: 250px 1fr;
      `
    }}
  }

  ${props => props.theme.breakpoints.up('md')} {
    ${props => {
      if (props.isBuyer)
        return `
        grid-template-areas:
          'heading-filters heading-filters new-quote-box'
          'notificationBottom notificationBottom notificationBottom'
          'resume resume resume'
          'filters results results';
        grid-template-columns: 250px 1fr 239px;
      `
      if (props.isSeller)
        return `
        grid-template-areas:
          'heading-filters heading-filters'
          'notificationBottom notificationBottom'
          'resume resume'
          'filters results';
        grid-template-columns: 250px 1fr;
      `
    }}
  }
`

export const Toast = styled(ToastBase)`
  margin: ${props => props.margin};
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  margin: ${props => props.margin};
  width: 100%;
  text-decoration: none;
`
